import { render, staticRenderFns } from "./MyApprovalsMyRequests.vue?vue&type=template&id=0df93e5b"
import script from "./MyApprovalsMyRequests.vue?vue&type=script&lang=js"
export * from "./MyApprovalsMyRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports